module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai5-c62fa27eca18bbcb0d0e46132a6b85da.jpg";